import { useEffect, useState } from "react";

import BasicBarStackGraph from "@/Components/EChartsGraph/BasicBarStackGraph";
import { useInfo } from "@/context/InfoProvider/InfoProvider";

import NewGraphHeader from "../NewGraphHeader/NewGraphHeader";
import { handleSourceData, INIT_FEED_DATA } from "./BrandEquityMethod";
import { useConfig } from "@/hooks/useConfig";

const BrandEquityGraph = (props) => {
  const {
    sourceData,
    handleDuration,
    durationSwitch,
    isDollarData,
    handleIsDollarData,
    currencySymbol,
  } = props;

  const { theme: colorTheme } = useInfo();
  const [feedData, setFeedData] = useState(INIT_FEED_DATA);
  const {
    config,
    config: { showReturnInsteadOfRevenue },
  } = useConfig();

  useEffect(() => {
    if (sourceData?.date) {
      handleSourceData({
        sourceData: sourceData,
        setFeedData: setFeedData,
        colorTheme: colorTheme,
        config: config,
      });
    }
  }, [sourceData, colorTheme]);

  const yAxisLabel = showReturnInsteadOfRevenue
    ? `Return ${isDollarData ? "" : "%"}`
    : `Sales ${isDollarData ? currencySymbol : "%"}`;

  return (
    <>
      <NewGraphHeader
        toggles={{
          isShow: true,
          allToggles: [
            {
              isSelected: durationSwitch,
              handleIsSelected: handleDuration,
              selectedLabel: "Show months",
              unSelectedLabel: "Show weeks",
            },
            {
              isSelected: isDollarData,
              handleIsSelected: handleIsDollarData,
              selectedLabel: showReturnInsteadOfRevenue ? "Return" : currencySymbol,
              unSelectedLabel: "%",
            },
          ],
        }}
        yAxisLabel={yAxisLabel}
      />
      <BasicBarStackGraph
        hoverData={{
          componentName: "Basic",
          data: {
            signBefore: isDollarData && !showReturnInsteadOfRevenue ? currencySymbol : "",
            signAfter: isDollarData ? "" : "%",
          },
        }}
        legendLabel={feedData.legendLabel}
        xAxisData={feedData.date}
        seriesData={feedData.seriesData}
        currencySymbol={currencySymbol}
        isDollarData={isDollarData}
      />
    </>
  );
};

export default BrandEquityGraph;
